<template>
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6 16.75c.69 0 1.25.56 1.25 1.25v4a.75.75 0 0 0 .75.75h14a.75.75 0 0 0 .75-.75v-4a1.25 1.25 0 1 1 2.5 0v4A3.25 3.25 0 0 1 22 25.25H8A3.25 3.25 0 0 1 4.75 22v-4c0-.69.56-1.25 1.25-1.25Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.12 12.12a1.25 1.25 0 0 1 1.76 0L15 16.23l4.12-4.11a1.25 1.25 0 0 1 1.76 1.76l-5 5c-.48.5-1.28.5-1.76 0l-5-5a1.25 1.25 0 0 1 0-1.76Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 4.75c.69 0 1.25.56 1.25 1.25v12a1.25 1.25 0 1 1-2.5 0V6c0-.69.56-1.25 1.25-1.25Z"
      fill="currentColor"
    />
  </svg>
</template>
